import { toast } from "react-toastify";

export default function errorMsg(msg) {

  var isErrorMessage = msg.toLowerCase().includes('mongodb') || msg.toLowerCase().includes('mongo');

    return toast.error(isErrorMessage ? 'Our databases seem to be down, please be patient with us.' : msg, {
      position: "bottom-center",
      autoClose: 3000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
      style: {
          // Apply custom styles
          minWidth: '250px',
          textAlign: 'center',
        },
      });
}